import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { AreaDefaultProps } from 'src/containers/area-container/AreaPropTypes';
import { AREA_ACTIONS } from '../actions/AreaActions';

const initialState = () => ({
    currentRecord: { ...AreaDefaultProps },
    currentRecordPopulated: { ...AreaDefaultProps },

    search: {
        data: [],
        currentPage: 0,
        pages: 0,
        count: 0,
    },

    upsertReqStatus: null,
    searchReqStatus: null,
});

export default (state = initialState(), action) => {
    switch (action.type) {
        // SEARCH
        case AREA_ACTIONS.AREA_SEARCH: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case AREA_ACTIONS.AREA_SEARCH_SUCCESS: {
            return {
                ...state,
                search: action.data,
                searchReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case AREA_ACTIONS.AREA_SEARCH_ERROR: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        // UPSERT
        case AREA_ACTIONS.AREA_UPSERT: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case AREA_ACTIONS.AREA_UPSERT_SUCCESS: {
            return {
                ...state,
                currentRecord: action.data,
                upsertReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case AREA_ACTIONS.AREA_UPSERT_ERROR: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        case AREA_ACTIONS.AREA_POPULATED_RECORD_UPDATE: {
            return {
                ...state,
                currentRecordPopulated: action.data,
            };
        }

        // RESET
        case AREA_ACTIONS.AREA_RESET: {
            return {
                ...state,
                currentRecord: { ...AreaDefaultProps },
            };
        }
        default:
            return state;
    }
};
